<template>
<div class="footer-background">
    <div class="footer-container">
        <div class="footer-content">
            <div style="margin-bottom: 10px; line-height: 150%;">
                <a href="https://twitter.com/ThreadOkApp" rel="nofollow" target="_blank">@ThreadOkApp</a>
                By <a href="https://twitter.com/rescoluis" rel="nofollow" target="_blank">@rescoluis</a> and <a href="https://twitter.com/teodora_dobre" rel="nofollow" target="_blank">@teodora_dobre</a> from <a href="https://monthlystart.com/" rel="nofollow" target="_blank"> Monthly Start</a>
            </div>
            <div style="margin-bottom: 20px; line-height: 150%;">Contact | hello@monthlystart.com</div>
            <div style="font-size:10px; line-height: 150%;"> Copyright © 2020 ThreadOk. All Rights Reserved. All the Twitter threads posted on ThreadOk belongs to their creators.</div>
        </div>
    </div>
</div>
</template>

<script></script>

<style scope>
</style>